import { useQuery, UseQueryOptions } from 'react-query';

import { getFacebookPages, Page } from '~/api/routes/auth/user';
import { useAuthSelector } from '~/theseus/containers/Auth';

type UsePagesQueryOptions<TError, TData> = UseQueryOptions<Page[], TError, TData>;

export function usePagesQuery<TError = unknown, TData = Page[]>(options?: Omit<UsePagesQueryOptions<TError, TData>, 'enabled'> = {}) {
  const accessToken = useAuthSelector(state => state.context.authToken);

  return useQuery(
    ['pages', accessToken],
    () => getFacebookPages(accessToken as string),
    {
      enabled: !!accessToken,
      ...options,
    },
  );
}
